import { ResultData, ResultType } from "../enums/index.js";

const defaultTS = new Date();

const resultsSorter = (resultA, resultB) => {
    if (!resultA || !resultB){
        return 0;
    }

    const resultAType = resultA[ResultData.Type.key];
    const resultBType = resultB[ResultData.Type.key];

    const resultATS = (
        resultAType === ResultType.Pitch.key
        ? resultA[ResultData.CreateDate.key]
        : resultAType === ResultType.Hit.key
            ? resultA[ResultData.CreateDate.key]
            : defaultTS
    );

    const resultBTS = (
        resultBType === ResultType.Pitch.key
        ? resultB[ResultData.CreateDate.key]
        : resultBType === ResultType.Hit.key
            ? resultB[ResultData.CreateDate.key]
            : defaultTS
    );

    const tsCompared = Date.parse(resultATS) - Date.parse(resultBTS);

    if (tsCompared === 0){
        // compare types... P(itch), H(it)
        return resultAType.localeCompare(resultBType) * -1;
    }

    return tsCompared;
};

export default resultsSorter;